import api from './client';

export async function register(email, password, inviteCode) {
  const { data } = await api.post('/api/auth/register', { email, password, inviteCode });
  return data.data; // { token, user }
}

export async function login(email, password) {
  const { data } = await api.post('/api/auth/login', { email, password });
  return data.data; // { token, user }
}

export async function logout() {
  await api.post('/api/auth/logout');
}

export async function refreshToken() {
  const { data } = await api.post('/api/auth/refresh');
  return data.data; // { token, user }
}

export function getStoredAuth() {
  // Live mode - no localStorage, auth comes from refresh token cookie
  return null;
}
